import React, { JSX } from "react";
import { HeaderBanner } from "components/header-banner/header-banner";
import { Tab, TabProps } from "components/tabs/tabs/tab/tab";
import { TabbedLayoutItem, TabbedLayout } from "components/tabs/tabbed-layout/tabbed-layout";
import { RouteUtils } from "utilities/route-utils";
import { sitemap } from "sitemap";
import { t } from "utilities/localization/t";
import "./instructor-enh-layout-header.scss";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface InstructorENHLayoutHeaderProps {}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME: string = "instructor-enh-layout-header";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const InstructorENHLayoutHeader: React.FC<InstructorENHLayoutHeaderProps> = (
    props: InstructorENHLayoutHeaderProps
): JSX.Element => {
    const tabbedLayoutItems: TabbedLayoutItem<TabProps>[] = [
        {
            path: RouteUtils.localizePath(sitemap.instructor.educationNetworkHub.requiredTrainings),
            tabComponent: Tab,
            tabDisplayDetails: {
                tabName: "requiredTrainings",
            },
        },
        {
            path: RouteUtils.localizePath(sitemap.instructor.educationNetworkHub.approvedToTeach),
            tabComponent: Tab,
            tabDisplayDetails: {
                tabName: "approvedToTeach",
            },
        },
        {
            path: RouteUtils.localizePath(sitemap.instructor.educationNetworkHub.resources),
            tabComponent: Tab,
            tabDisplayDetails: {
                tabName: "resources",
            },
        },
        {
            path: RouteUtils.localizePath(sitemap.instructor.educationNetworkHub.profile),
            tabComponent: Tab,
            tabDisplayDetails: {
                tabName: "instructorProfile",
            },
        },
    ];

    return (
        <div className={CSS_CLASS_NAME}>
            <HeaderBanner title={t("educationNetworkHub")} />
            <TabbedLayout cssClassName={`${CSS_CLASS_NAME}__tabs`} tabs={tabbedLayoutItems} />
        </div>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { InstructorENHLayoutHeader };

// #endregion Exports
